import { useMemo } from 'react';
import { Helmet } from 'react-helmet';

import { findCDNBaseUrlFromUrl } from '@zooplus/commons-lang';

import { getAppConfig } from '@config/get-app-config';
import { useTranslation } from '@hooks/use-translations';
import { getMktExternalUrl, getKeycloakUrl } from '@utilities/utils';

const MetaTag = () => {
  const { site, environment } = getAppConfig();
  const { t } = useTranslation();
  const mktExternalUrl = getMktExternalUrl(environment);
  const keycloakUrl = `${getKeycloakUrl(environment)}.${site.domain}`;

  const title = useMemo(() => {
    const match = site.domain.match(/zoochic|zooplus|bitiba|zoohit/);
    const siteName = match ? match[0] : site.realm;

    return `${t('cart.overview.title')} | ${siteName}`;
  }, [site.domain, site.realm, t]);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <link rel="icon" href="/favicon.ico" />
      <title>{title}</title>
      <meta id="meta-robots" name="robots" content="noindex, follow" />
      <link rel="preconnect" href={findCDNBaseUrlFromUrl()} />
      <link rel="preconnect" href={mktExternalUrl} />
      <link rel="preconnect" href={keycloakUrl} />
    </Helmet>
  );
};

export default MetaTag;
